import { useQuery } from "@tanstack/react-query";
import { fetcher } from "./fetcher";

const useSearchList = ({ search, search2, searchOrigin }: { search: string, search2?: string, searchOrigin?: string }): [any[], boolean] => {
    const { data: explodeDt, isFetching } = useQuery({
        queryKey: [
            "search",
            {
                search,
                search2: search2 ?? null,
                risk: true,
                searchOrigin: searchOrigin ?? null,
            },
        ],
        queryFn: () => fetcher(`/api/search?search=${encodeURIComponent(search)}&search2=${search2}&risk=true&searchOrigin=${searchOrigin}`),
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        staleTime: 0,
    });

    // 초기 로딩 상태
    const isValid = !explodeDt && isFetching;


    const data = explodeDt
        ? search.length === 0
            ? [].concat(...explodeDt).slice(0, 30)
            : [].concat(...explodeDt)
        : [];
    return [data, isValid];
}

export const usePortSearch = ({ search, search2, isTrending = false, searchOrigin }: { search: string, search2?: string, searchOrigin?: string, isTrending?: boolean }): [any[], boolean] => {
    const { data: explodeDt, isFetching } = useQuery({
        queryKey: [
            "search-port",
            {
                search,
                search2: search2 ?? null,
                price: true,
                trending: isTrending,
                searchOrigin: searchOrigin ?? null,
            },
        ],
        enabled: Boolean(search),
        queryFn: () => fetcher(`/api/search?search=${encodeURIComponent(search)}&search2=${search2}&price=true&trending=${isTrending}&searchOrigin=${searchOrigin}`),
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        staleTime: 0,

    });

    // 초기 로딩 상태
    const isValid = !explodeDt && isFetching;

    const data = explodeDt ? [].concat(...explodeDt) : [];
    return [data, isValid];
}
export const usePortTrending = ({ isTrending = false }: { isTrending?: boolean }): [any[], boolean] => {
    const { data: explodeDt, isFetching, isLoading } = useQuery({
        queryKey: ["search-trending"],
        queryFn: () => fetcher(`/api/search?price=true&trending=${isTrending}`),
        staleTime: 1000 * 60 * 30,
        refetchOnWindowFocus: false,
    });

    // 초기 로딩 상태
    const isValid = !explodeDt && isFetching;

    const data = explodeDt ? [].concat(...explodeDt) : [];
    return [data, isLoading];
}

export const useSearchListVerLight = ({ search, search2, searchOrigin, riskFilter }: { search: string, search2?: string, searchOrigin?: string, riskFilter?: boolean }): [any[], boolean] => {
    const { data: searchData, isFetching } = useQuery({
        queryKey: [
            "detailsearch",
            {
                search,
                search2: search2 ?? null,
                searchOrigin: searchOrigin ?? null,
                riskFilter: Boolean(riskFilter),
            },
        ],
        enabled: Boolean(search),
        queryFn: () => fetcher(`/api/detail/detailsearch?search=${encodeURIComponent(search)}&search2=${search2}&searchOrigin=${searchOrigin}${riskFilter ? `&riskFilter=true` : ""}`),
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        staleTime: 0,
    });

    // 초기 로딩 상태
    const isValid = !searchData && isFetching;


    const data = searchData
        ? [].concat(...searchData)
        : [];
    return [data, isValid];
}

export const useSearchDefault = (): [any[], boolean] => {
    const { data: defaultSearchData, isFetching } = useQuery({
        queryKey: ["detailsearch-default"],
        queryFn: () => fetcher(`/api/detail/detailsearch`),
        refetchOnMount: true,
        refetchOnWindowFocus: false,
    });

    // 초기 로딩 상태
    const isValid = !defaultSearchData && isFetching;


    const data = defaultSearchData ? [].concat(...defaultSearchData) : [];
    return [data, isValid];
}

export default useSearchList;